import React from "react";

interface InstagramIconProps {
  className?: string;
  fill?: string;
  height?: number;
  width?: number;
}

const InstagramIcon = ({
  className,
  fill,
  height = 30,
  width = 30
}: InstagramIconProps) => (
  <svg width={width} height={height} className={className}>
    <g fill={fill}>
      <path d="M15 2.703c4.005 0 4.48.015 6.061.087 1.708.078 3.291.42 4.51 1.64 1.219 1.218 1.56 2.802 1.639 4.51.072 1.58.088 2.055.088 6.06 0 4.006-.016 4.48-.088 6.062-.078 1.707-.42 3.291-1.639 4.51-1.219 1.218-2.803 1.56-4.51 1.638-1.581.073-2.056.088-6.061.088s-4.48-.015-6.061-.088c-1.708-.077-3.292-.42-4.51-1.638-1.219-1.219-1.56-2.803-1.639-4.51-.072-1.583-.087-2.057-.087-6.062 0-4.005.015-4.48.087-6.061.078-1.708.42-3.292 1.64-4.51C5.647 3.21 7.231 2.869 8.94 2.79c1.58-.072 2.055-.087 6.06-.087zM15 0c-4.074 0-4.584.017-6.185.09C6.378.202 4.237.8 2.517 2.518.8 4.236.202 6.377.09 8.815.017 10.415 0 10.926 0 15s.017 4.584.09 6.185c.112 2.437.709 4.578 2.428 6.298 1.718 1.718 3.86 2.316 6.298 2.427 1.6.073 2.11.09 6.184.09s4.584-.017 6.185-.09c2.437-.112 4.578-.709 6.298-2.428 1.718-1.718 2.316-3.86 2.427-6.298.073-1.6.09-2.11.09-6.184s-.017-4.584-.09-6.185c-.112-2.437-.709-4.578-2.428-6.298C25.764.8 23.622.201 21.184.09 19.584.017 19.074 0 15 0z" />
      <path d="M15 7.298a7.703 7.703 0 100 15.405 7.703 7.703 0 000-15.405zM15 20a5 5 0 110-10 5 5 0 010 10z" />
      <circle cx={23.007} cy={6.993} r={1.8} />
    </g>
  </svg>
);

export default InstagramIcon;
